import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/hero-section.css';

function HeroSection({ handleJoinClick }) {
  const navigate = useNavigate();

  const handleScrollPromptClick = () => {
    window.scrollBy({
      top: Math.round(window.innerHeight * 0.85),
      behavior: 'smooth',
    });
  };

  return (
    <section className="hero-section-kinetic">
      <div className="hero-background">
        <div className="hero-gradient-overlay"></div>
        <div className="hero-orb hero-orb--left"></div>
        <div className="hero-orb hero-orb--right"></div>
        <div className="hero-network-bg" />
      </div>

      <div className="hero-container">
        <div className="hero-left-column">
          <p className="hero-audience-note">
            Built for companies that need a security rating customers can verify.
          </p>
          <h1 className="hero-title-kinetic">
            Prove Your Security.<br />
            <span className="hero-accent">Build Customer Trust.</span>
          </h1>

          <button
            type="button"
            className="hero-scroll-cta"
            onClick={handleScrollPromptClick}
            aria-label="Scroll down to learn more"
          >
            <span className="hero-scroll-cta-copy">
              Get your free cybersecurity rating.
            </span>
            <span className="hero-scroll-cta-subcopy">Scroll to see how it works</span>
          </button>

          <p className="hero-supporting-note">
            In about 10 minutes, get a shareable score page and dashboard view.
          </p>

          <p className="hero-speed-note">
            Get started in under 10 minutes.
          </p>

          <div className="hero-actions-kinetic">
            <button className="btn-kinetic btn-primary-kinetic" onClick={handleJoinClick}>
              Join the Network
            </button>
            <button className="btn-kinetic btn-secondary-kinetic" onClick={() => navigate('/companies')}>
              Browse Companies
            </button>
          </div>

          <button
            type="button"
            className="hero-scroll-arrow-button"
            onClick={handleScrollPromptClick}
            aria-label="Scroll down to learn more"
          >
            <span className="hero-scroll-arrow" aria-hidden="true">↓</span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
